import React from "react";
import * as Styled from "./styled";
import { useForm } from "react-hook-form";

function Edit(props) {
  const { register, handleSubmit } = useForm();
  const onSubmit = (data) => props.onProceed(data);

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Styled.Title>Edit</Styled.Title>

      <Styled.SubTitle>Name your land</Styled.SubTitle>
      <Styled.BaseTextField
        {...register("name")}
        required
        autoComplete="off"
        inputProps={{ minLength: 3 }}
        name="name"
        placeholder="Enter a name..."
        variant="outlined"
        defaultValue={props.data?.name}
      />

      <Styled.SubTitle>Name the owner</Styled.SubTitle>
      <Styled.BaseTextField
        {...register("owner")}
        required
        autoComplete="off"
        inputProps={{ minLength: 3 }}
        name="owner"
        placeholder="Enter the owner's name..."
        variant="outlined"
        defaultValue={props.data?.ownerName}
      />

      <Styled.SubTitle>Add the description</Styled.SubTitle>
      <Styled.BaseTextField
        {...register("description")}
        autoComplete="off"
        multiline
        maxRows={3}
        name="description"
        placeholder="Enter a description..."
        variant="outlined"
        defaultValue={props.data?.description}
      />

      <Styled.Button type="submit">Proceed</Styled.Button>
    </form>
  );
}

export default Edit;
